import styled from 'styled-components';

export default styled.span`
  width: 15px;
  height: 14px;
  top: 2px;
  position: relative;
  display: inline-block;
  border: 1px solid grey;
  border-radius: 10px;
  background-color: ${({ color }) => color};
`;
